import * as Yup from "yup";

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const institutionSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name field cannot be empty")
    .max(255, "Name cannot exceed 255 characters"),

  logo: Yup.string().nullable(),

  email: Yup.string().email("Invalid email address").nullable(),

  location: Yup.string().required("District is required"),

  contact: Yup.string().nullable(),

  website_url: Yup.string().url("Website URL must be valid").nullable(),

  facebook: Yup.string().url("Facebook link must be valid").nullable(),

  linkedin: Yup.string().url("LinkedIn link must be valid").nullable(),

  twitter: Yup.string().url("Twitter link must be valid").nullable(),

  institution_category_id: Yup.string().required(
    "Institution category is required"
  ),

  ownership_id: Yup.string().required("Ownership Type is required"),

  license_category_id: Yup.string().required("License Category is required"),

  subscription_expiry_date: Yup.string().nullable(),

  focus_areas: Yup.array()
    .of(Yup.string().matches(uuidRegex, "Focus Area must be a valid UUID"))
    .min(1, "At least one Focus Area is required"),

  establishment_year: Yup.string().required("Establishment Year is required"),

  region: Yup.string().required("Region Year is required"),

  code: Yup.string().required("Code Year is required"),

  vc_name: Yup.string().nullable(),
});
